import { Pressable, View } from "react-native";
import { spacing, useTheme } from "~/styles/theme";
import { BodyText, Heading3 } from "./Text";
import { Icon } from "./Icon";
import { RuleLine } from "./RuleLine";

export function ModalHeader({
  title,
  onClose,
  actionLabel,
  onAction,
  actionDisabled,
}: {
  title: string;
  onClose: () => void;
  actionLabel?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
}) {
  const { colors } = useTheme();
  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingHorizontal: spacing.xs,
          paddingVertical: spacing.xs,
        }}
      >
        <Pressable
          onPress={onClose}
          style={{
            width: 56,
            height: 44,
            alignItems: "center",
            justifyContent: "center",
          }}
          accessibilityRole="button"
          accessibilityLabel="Close"
        >
          <Icon name="x" />
        </Pressable>
        <Heading3>{title}</Heading3>
        <Pressable
          onPress={onAction}
          disabled={!onAction || actionDisabled}
          style={{
            minWidth: 56,
            height: 44,
            paddingRight: spacing.md,
            alignItems: "flex-end",
            justifyContent: "center",
          }}
        >
          {onAction ? (
            <BodyText
              weight="semibold"
              color={actionDisabled ? colors.placeholder : colors.accent}
            >
              {actionLabel ?? "Save"}
            </BodyText>
          ) : null}
        </Pressable>
      </View>
      <View style={{ marginHorizontal: spacing.lg }}>
        <RuleLine strong />
      </View>
    </View>
  );
}
